import React from 'react'
import { Button } from '@/components/ui/button'
import { PaymentProviderSuccessValidation } from 'api/PaymentProvider/Types/PaymentProviderValidation'
import { FormBaseErrorMessage, FormBaseRow } from 'components/Form/Form.styles'
import { Field, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

import {
  ActionHeader,
  FormFieldBlock,
  FormFieldGroup,
  FormFieldLabel,
  HeaderCol,
  SectionBlock,
  TransactionTemplate,
} from '../../Transactions.styles'

export interface ProviderValidationFormValues {
  firstName?: string
  lastName?: string
  email?: string
  methodId?: string
}

const ProviderValidationFormUI: React.FC<FormikProps<ProviderValidationFormValues> & OuterProps> = (
  props
) => {
  const { paymentProviderSuccessValidationFields: fields, errors } = props

  return (
    <TransactionTemplate>
      <form onSubmit={props.handleSubmit}>
        <ActionHeader>
          <HeaderCol grow />
          <HeaderCol>
            <Button type='submit'>Validate</Button>
          </HeaderCol>
        </ActionHeader>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>FirstName</FormFieldLabel>
            <FormFieldGroup>
              <Field name='firstName' type='text' />
            </FormFieldGroup>
          </FormBaseRow>
          {errors.firstName && <FormBaseErrorMessage>{errors.firstName}</FormBaseErrorMessage>}
        </FormFieldBlock>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>LastName</FormFieldLabel>
            <FormFieldGroup>
              <Field name='lastName' type='text' />
            </FormFieldGroup>
          </FormBaseRow>
          {errors.lastName && <FormBaseErrorMessage>{errors.lastName}</FormBaseErrorMessage>}
        </FormFieldBlock>
        <FormFieldBlock>
          <FormBaseRow>
            <FormFieldLabel>Email</FormFieldLabel>
            <FormFieldGroup>
              <Field name='email' type='text' />
            </FormFieldGroup>
          </FormBaseRow>
          {errors.email && <FormBaseErrorMessage>{errors.email}</FormBaseErrorMessage>}
        </FormFieldBlock>
        {fields && (
          <SectionBlock>
            <FormFieldLabel>Validation Check Results</FormFieldLabel>
            <FormFieldBlock>
              <FormBaseRow>
                <FormFieldLabel>Email</FormFieldLabel>
                <FormFieldGroup>
                  <input type='text' value={fields.userEmail} disabled />
                </FormFieldGroup>
              </FormBaseRow>
            </FormFieldBlock>
            <FormFieldBlock>
              <FormBaseRow>
                <FormFieldLabel>Firstname MATCH</FormFieldLabel>
                <FormFieldGroup>
                  <input type='text' value={fields.userFirstName} disabled />
                </FormFieldGroup>
              </FormBaseRow>
            </FormFieldBlock>
            <FormFieldBlock>
              <FormBaseRow>
                <FormFieldLabel>Lastname MATCH</FormFieldLabel>
                <FormFieldGroup>
                  <input type='text' value={fields.userLastName} disabled />
                </FormFieldGroup>
              </FormBaseRow>
            </FormFieldBlock>
            <FormFieldBlock>
              <FormBaseRow>
                <FormFieldLabel>Account Info</FormFieldLabel>
                <FormFieldGroup>
                  <textarea rows={3} value={fields.paymentAccountInfo} disabled />
                </FormFieldGroup>
              </FormBaseRow>
            </FormFieldBlock>
            <FormFieldBlock>
              <FormBaseRow>
                <FormFieldLabel>Check Pass</FormFieldLabel>
                <FormFieldGroup>
                  <input type='text' value={fields.result ? 'PASS' : 'FAIL'} disabled />
                </FormFieldGroup>
              </FormBaseRow>
            </FormFieldBlock>
          </SectionBlock>
        )}
      </form>
    </TransactionTemplate>
  )
}

interface OuterProps {
  firstName?: string
  lastName?: string
  email?: string
  methodId?: string
  paymentProviderSuccessValidationFields: PaymentProviderSuccessValidation | null
  onSubmit(values: FormSubmitValues<ProviderValidationFormValues>): Promise<void>
}

export const ProviderValidationForm = withFormik<OuterProps, ProviderValidationFormValues>({
  mapPropsToValues: (props) => {
    return {
      firstName: props.firstName,
      lastName: props.lastName,
      email: props.email || '',
      methodId: props.methodId,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    await props.onSubmit(values)
    setSubmitting(false)
  },
  validate: (values) => {
    const errors: FormikErrors<ProviderValidationFormValues> = {}
    if (!values.firstName) {
      errors.firstName = 'Required'
    }
    if (!values.lastName) {
      errors.lastName = 'Required'
    }
    if (!values.email) {
      errors.email = 'Required'
    }
    return errors
  },
  enableReinitialize: true,
  isInitialValid: false,
})(ProviderValidationFormUI)
